module.exports = __webpack_public_path__ + "img/emoji-okay.d5e07896.png";